<template>
  <b-form-group
    label="9. Penggunaan"
    label-for="penggunaan"
  >
    <b-form-select
      v-model="penggunaan"
      :options="dataPenggunaan"
      disabled
    />

    <b-col
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <!-- no. 2 -->
      <b-form-group
        v-if="penggunaan === '2'"
        label="Digunakan Untuk"
        label-for="digunakanUntuk"
      >
        <slot />
      </b-form-group>

      <!-- no. 3 -->
      <div v-else-if="penggunaan === '3'">
        <slot />
      </div>

      <!-- no. 4 -->
      <div v-else-if="penggunaan === '4'">
        <slot />
      </div>

      <!-- no. 5 -->
      <div v-else-if="penggunaan === '5'">
        <slot />
      </div>
    </b-col>
  </b-form-group>
</template>
<script>
export default {
  props: {
    penggunaan: { type: String, default: null },
  },
  data() {
    return {
      dataPenggunaan: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Tidak Digunakan' },
        { value: '2', text: 'Digunakan Sendiri Seluruhnya Oleh PD/UKPD' },
        { value: '3', text: 'Digunakan Seluruhnya Oleh PD/UKPD Lain' },
        {
          value: '4',
          text: 'Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain',
        },
        { value: '5', text: 'Digunakan Instansi/Pihak Lain Seluruhnya' },
      ],
    }
  },
}
</script>
